import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/home/HeroSection';
import { PartnersSection } from '../components/home/PartnersSection';
import { WhatWeDoSection } from '../components/home/WhatWeDoSection';
import { TestimonialSection } from '../components/home/TestimonialSection';
import { AboutFounderSection } from '../components/home/AboutFounderSection';
import { Footer } from '../components/ui/Footer';
import { LoadingScreen } from '../components/ui/LoadingScreen';
export function HomePage() {
  const [isLoading, setIsLoading] = useState(true);
  const handleVideoLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };
  return <div className="bg-black" data-id="element-266">
      <LoadingScreen isLoading={isLoading} data-id="element-267" />
      <Header data-id="element-268" />
      <HeroSection onVideoLoad={handleVideoLoad} data-id="element-269" />
      <PartnersSection data-id="element-270" />
      <WhatWeDoSection data-id="element-271" />
      <TestimonialSection data-id="element-272" />
      <AboutFounderSection data-id="element-273" />
      <Footer data-id="element-274" />
    </div>;
}